export const tr = {
    'changes-confirm': 'Değişiklikler kaydedilmeyecek. Devam etmek istiyor musunuz?',
    'no-phrases-for-dynamic-campaigns': 'Dinamik kampanya gruplarına sözcük grupları eklenemez',
    'no-phrases-for-smart-banners': "Akıllı banner'lara sözcük grupları eklenemez",
    'refine-phrases-error': 'Sözcük grupları yüklenirken hata oluştu. Lütfen işlemi tekrar deneyin.',
    'refine-phrases-shows-error': 'Gösterim tahmini netleştirilemedi.',
    'start-phrases-error': 'Sözcük grupları yüklenirken hata oluştu. Lütfen sayfayı yenileyip tekrar deneyin.'
};
